import {JsonPlatformRestaurantAvailability} from '@deliveryhero/vendor-growth-api-client';
import {store} from '@deliveryhero/vendor-web-core';
import {ActionReducerMapBuilder, SliceCaseReducers} from '@reduxjs/toolkit';
import {HighDemandFlag} from '../interfaces/HighDemandFlag';
import {authSessionRemovedExtra} from '../reducers/authSessionRemovedExtra';
import {
  availabilitiesErrorDismissed,
  availabilitiesErrorOccured,
} from '../reducers/availabilitiesError';
import {availabilitiesLoadingChanged} from '../reducers/availabilitiesLoadingChanged';
import {availabilitiesReceived} from '../reducers/availabilitiesReceived';
import {availabilitiesUpdated} from '../reducers/availabilitiesUpdated';
import {availabilityBannerToggled} from '../reducers/availabilityBannerToggled';
import {availabilityEnabled} from '../reducers/availabilityEnabled';
import {availabilityHighDemandFlagChanged} from '../reducers/availabilityHighDemandFlagChanged';

export const AVAILABILITY_STATE = 'availability-state';
export const AVAILABILITIES_RECEIVED = `${AVAILABILITY_STATE}/availabilitiesReceived`;
export const AVAILABILITIES_UPDATED = `${AVAILABILITY_STATE}/availabilitiesUpdated`;
export const AVAILABILITIES_LOADING_CHANGED = `${AVAILABILITY_STATE}/availabilitiesLoadingChanged`;
export const AVAILABILITIES_ERROR_OCCURED = `${AVAILABILITY_STATE}/availabilitiesErrorOccured`;
export const AVAILABILITIES_ERROR_DISMISSED = `${AVAILABILITY_STATE}/availabilitiesErrorDismissed`;
export const AVAILABILITY_ENABLED = `${AVAILABILITY_STATE}/availabilityEnabled`;
export const AVAILABILITY_BANNER_TOGGLED = `${AVAILABILITY_STATE}/availabilityBannerToggled`;
export const AVAILABILITY_HIGH_DEMAND_FLAG_CHANGED = `${AVAILABILITY_STATE}/availabilityHighDemandFlagChanged`;
export const AVAILABILITY_DRAWER_OPENING_TRIGGERED = `${AVAILABILITY_STATE}/availabilityDrawerOpeningTriggered`;

export interface AvailabilityStore {
  [AVAILABILITY_STATE]?: AvailabilityStateSlice;
}

export interface AvailabilityStateSlice {
  isEnabled: boolean;
  availabilities: JsonPlatformRestaurantAvailability[] | undefined;
  isLoading: boolean;
  error: {description: string} | undefined;
  restartPollingTimestamp: number | undefined;
  isBannerVisible: boolean;
  highDemandFlag: HighDemandFlag | undefined;
}

const slice = store.createSlice<
  AvailabilityStateSlice,
  SliceCaseReducers<AvailabilityStateSlice>,
  typeof AVAILABILITY_STATE
>({
  name: AVAILABILITY_STATE,
  initialState: {
    isEnabled: false,
    availabilities: undefined,
    isLoading: false,
    error: undefined,
    restartPollingTimestamp: undefined,
    isBannerVisible: false,
    highDemandFlag: undefined,
  },
  reducers: {
    availabilitiesReceived,
    availabilitiesUpdated,
    availabilitiesLoadingChanged,
    availabilitiesErrorOccured,
    availabilitiesErrorDismissed,
    availabilityEnabled,
    availabilityBannerToggled,
    availabilityHighDemandFlagChanged,
  },
  extraReducers: (builder: ActionReducerMapBuilder<AvailabilityStateSlice>): void => {
    builder.addCase('authentication/sessionRemoved', authSessionRemovedExtra);
  },
});

export default slice;
